import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

// Theme colors set here so we can easily manipulate them with Polished
const theme = {
  primaryColor: '#5d7ae3',
  secondaryColor: '#3B1A4F',
  greyLight: '#8B83A0',
  primaryColorWashed: '#E0E9F8'
}

const Theme = ({ children }) =>
  <ThemeProvider theme={theme}>
    <main>
      {children}
    </main>
  </ThemeProvider>

Theme.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
}

export default Theme



// WEBPACK FOOTER //
// ./src/components/Theme/Theme.js